import type { App } from "@open-booking/server";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type ListResponse = App["~Routes"]["cautions"]["me"]["get"]["response"]["200"];
type DetailResponse = App["~Routes"]["cautions"][":id"]["get"]["response"]["200"];

export const tenantCautionApi = createApi({
	reducerPath: "tenantCautionApi",
	baseQuery: edenBaseQuery(),
	tagTypes: ["TenantCaution"],
	endpoints: (builder) => ({
		getTenantCautions: builder.query<ListResponse, void>({
			query: (): EdenCall<ListResponse> => (client) => client.cautions.me.get(),
			providesTags: ["TenantCaution"],
		}),
		getTenantCautionDetail: builder.query<DetailResponse, string>({
			query:
				(id): EdenCall<DetailResponse> =>
				(client) =>
					client.cautions({ id }).get(),
			providesTags: (_r, _e, id) => [{ type: "TenantCaution", id }],
		}),
	}),
});

export const { useGetTenantCautionsQuery, useGetTenantCautionDetailQuery } = tenantCautionApi;
